export default {
  SET_GROWTHBOOK_PAYLOAD(state, payload) {
    state.growthbookPayload = payload
  },
}
